import AllEventsContent from './AllEventsContent'
export default AllEventsContent